// prettier-ignore
export const adminOnly = () => ('me { access { system } }');
export const nonParent = (user) => (user.type !== 'PARENT');
export const nonStudent = (user) => (user.type !== 'STUDENT');
export const anyone = () => (true);
